import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Paper, Button, Stack } from '@mui/material';

export default function ResidenceDetails() {
  const { id } = useParams();
  const nav = useNavigate();
  const [r, setR] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`/api/residences/${id}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const j = await res.json();
        setR(j?.residence || j);
      } catch (e) {
        setErr(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) return <Box p={4} display="flex" justifyContent="center"><CircularProgress /></Box>;
  if (err) return <Alert severity="error" sx={{ m: 3 }}>{String(err)}</Alert>;
  if (!r) return null;

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight={600} mb={2}>{r.name}</Typography>
      <Paper sx={{ p: 3 }}>
        <Typography><b>Adresse :</b> {r.address}</Typography>
        <Typography><b>Ville :</b> {r.postalCode} {r.city}</Typography>
        <Typography><b>Appartements :</b> {r.numberOfApartments ?? '—'}</Typography>
      </Paper>

      <Stack direction="row" spacing={1} mt={2}>
        <Button variant="contained" component={RouterLink} to={`/residences/${id}/edit`} disableElevation>
          Modifier
        </Button>
        <Button onClick={() => nav('/residences')}>Retour</Button>
      </Stack>
    </Box>
  );
}
